import { AppError } from "./errors";

export interface UserMessage {
  title: string;
  description: string;
  retry: boolean;
}

export const getErrorMessage = (err: AppError): UserMessage => {
  switch (err.kind) {
    case "offline":
      return {
        title: "Keine Internetverbindung",
        description:
          "Bitte überprüfe deine Verbindung und versuche es erneut.",
        retry: true,
      };
    case "network":
      return {
        title: "Netzwerkfehler",
        description: "Der Server ist gerade nicht erreichbar.",
        retry: true,
      };
    case "timeout":
      return {
        title: "Zeitüberschreitung",
        description: "Die Anfrage hat zu lange gedauert.",
        retry: true,
      };
    case "server":
      return {
        title: "Serverfehler",
        description:
          "Etwas ist schiefgelaufen. Bitte versuche es später erneut.",
        retry: true,
      };
    case "rate_limited":
      return {
        title: "Zu viele Anfragen",
        description: "Bitte warte einen Moment und versuche es nochmal.",
        retry: true,
      };
    case "unauthorized":
      return {
        title: "Sitzung abgelaufen",
        description: "Bitte melde dich erneut an.",
        retry: false,
      };
    case "forbidden":
      return {
        title: "Keine Berechtigung",
        description: "Du kannst diese Aktion nicht ausführen.",
        retry: false,
      };
    case "not_found":
      return {
        title: "Nicht gefunden",
        description: "Der angeforderte Inhalt existiert nicht.",
        retry: false,
      };
    case "validation":
      return {
        title: "Ungültige Eingabe",
        description: err.message || "Bitte überprüfe deine Angaben.",
        retry: false,
      };
    default:
      return {
        title: "Fehler",
        description: "Ein unbekannter Fehler ist aufgetreten.",
        retry: true,
      };
  }
};
